import { MentorumRizasi, mentorumHataMetni } from "./Mentorum";
import {
  VeliBagiDogrulama,
  VeliBagiDogrulamaGirisi,
  veliBagiSayfasiniOku,
} from "./VeliBagiDogrulama";
import { Karne } from "./Karne";
import { Onaylarim, RIZA_ADI } from "./Onaylarim";
import { haftaAraligi } from "./veli-hafta";
import { useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  Alan,
  BosDurum,
  Buton,
  CizgiGrafik,
  DenemeNetGrafigi,
  denemeNoktalari,
  Halka,
  Iskelet,
  IskeletKart,
  Kart,
  Sekmeler,
} from "@koclukpanel/ui";
import { Bildirimlerim } from "./Bildirimlerim";
import { HedefNetleriGorunumu, hedefYokYaniMi } from "./HedefNetlerim";
import { ProfilGorselim } from "./ProfilGorselim";
import { Mesajlar } from "./Mesajlar";
import { VeliYaklasanGorusmeleri } from "./YaklasanGorusmeler";
import { Duyurularim } from "./Duyurularim";
import { VeliSiparisOnayi } from "./VeliSiparisOnayi";
import { veliSiparisOnaylari } from "./api-magaza";
import { CanliBilgilendirmeSayfasi } from "./CanliBilgilendirmeSayfasi";
import { useCanliModulAcik } from "./canli-izleme";
import {
  api,
  ApiHatasi,
  bildirimSayaci,
  denemeTrendi,
  hedefNetim,
  mesajKutum,
  veliCocuklarim,
  rizaDurumu,
  veliGorusmeler,
  veliOzet,
  veliRapor,
  veliRaporPdf,
  veliRaporlar,
  veliYorumYaz,
  type VeliCocuk,
  type VeliOzet,
} from "./api";

/**
 * VELI PORTALI — F-PAR
 *
 * Panelin icinde ayri bir gorunum: veli giris yaptiginda personel
 * menusunu degil BU ekrani goruyor.
 *
 * ================================================================
 * BURADA GOSTERILMEYENLER (F-PAR-07)
 * ================================================================
 * Ogrenci tanima notu · korumali PDR notu · uzmanin ozel notlari ·
 * liderlik tablosu · diger ogrencilerin verisi.
 *
 * Bunlar "gizlenmiyor", SUNUCUDAN HIC GELMIYOR: veli uclari o
 * tablolara dokunmuyor. Arayuzde bir filtre olsaydi, o filtreyi
 * atlayan tek bir ekran butun listeyi sizdirirdi.
 */
export function VeliPortali() {
  const [dogrulamaSayfasi, setDogrulamaSayfasi] = useState(veliBagiSayfasiniOku);
  const istemci = useQueryClient();
  const [seciliCocuk, setSeciliCocuk] = useState<string | null>(null);
  const [acikRapor, setAcikRapor] = useState<string | null>(null);
  const [mesajAcik, setMesajAcik] = useState(false);
  const [bildirimAcik, setBildirimAcik] = useState(false);
  const [gorselAcik, setGorselAcik] = useState(false);
  const [onayAcik, setOnayAcik] = useState(false);
  const [siparisAcik, setSiparisAcik] = useState(false);
  const [canliBilgiAcik, setCanliBilgiAcik] = useState(false);
  /*
    F-LIV-07 — veli canli LISTEYI goremez, yalniz BILGILENDIRILIR: bu portal listenin ucunu hic
    cagirmiyor, yalniz modul durumunu soruyor (yalniz KESIN kapaliysa baglanti gorunmez, ogrenci notuyla ayni kural).
  */
  const canliAcik = useCanliModulAcik(true);

  const cocuklar = useQuery<VeliCocuk[]>({
    queryKey: ["veli-cocuklarim"],
    queryFn: veliCocuklarim,
  });

  // F-MNT-05 — bağlantı seçili çocuğa bağlı değildir; postada belirtilen bağ sunucuda denetlenir.
  if (dogrulamaSayfasi) {
    return <VeliBagiDogrulama sayfa={dogrulamaSayfasi} onKapat={() => setDogrulamaSayfasi(null)} />;
  }

  // Kart biçimli iskelet: portal kartlardan oluşuyor; satır iskeleti
  // yüklenince yerini alan düzenle hiç benzeşmiyor ve sayfa zıplıyordu
  // (UI/UX Dalga 1, veli yükleme).
  if (cocuklar.isPending) return <IskeletKart adet={3} />;

  if (cocuklar.isError) {
    return (
      <BosDurum
        ton="hata"
        baslik="Bilgiler alınamadı"
        aciklama={cocuklar.error instanceof ApiHatasi ? cocuklar.error.message : undefined}
        eylem={
          <Buton gorunum="ikincil" onClick={() => void cocuklar.refetch()}>
            Tekrar dene
          </Buton>
        }
      />
    );
  }

  if (cocuklar.data.length === 0) {
    return (
      /*
        Sunucu artık bağı olmayan VELİYE `200 []` dönüyor (eskiden 403
        "Bu hesap bir veli hesabı değil." — UI/UX Dalga 1, V4/F14). Bu
        boş durum o yüzden gerçekten görünür oldu: velinin yapacağı tek
        şey kuruma haber vermek, cümle bunu söylüyor.
      */
      <BosDurum
        baslik="Henüz bağlı öğrenciniz yok"
        aciklama="Hesabınız açıldı ama çocuğunuzun kaydı henüz bağlanmamış. Kurumla iletişime geçin; bağlandığında çocuğunuzun haftası burada görünür."
      />
    );
  }

  const cocuk = cocuklar.data.find((c) => c.id === seciliCocuk) ?? cocuklar.data[0]!;
  const aktif = cocuk.id;
  if (onayAcik && cocuk.userId) {
    return (
      <div className="flex flex-col gap-3">
        <Buton gorunum="sessiz" onClick={() => setOnayAcik(false)}>
          Çocuğumun sayfasına dön
        </Buton>
        <Onaylarim
          key={cocuk.userId}
          hedef={{ userId: cocuk.userId, ad: cocuk.ad }}
          onDegisti={() =>
            istemci.invalidateQueries({ queryKey: ["cocuk-onaylari", cocuk.userId] })
          }
        />
      </div>
    );
  }

  /*
    SİPARİŞ ONAYI — oyunlaştırma dalga 2 / 7a. `onayAcik` ile aynı desen: ekranı
    devralıyor ve geri düğmesi çocuğun sayfasına dönüyor. Sorgu anahtarı giriş
    kartıyla ortak: onay ya da ret sonrası kartın sayısı kendiliğinden düşüyor.
  */
  if (siparisAcik) {
    return (
      <div className="flex flex-col gap-3">
        <Buton gorunum="sessiz" onClick={() => setSiparisAcik(false)}>
          Çocuğumun sayfasına dön
        </Buton>
        <VeliSiparisOnayi />
      </div>
    );
  }

  /* Bilgilendirme de ekrani devraliyor — onay ve siparis ekranlariyla ayni desen. */
  if (canliBilgiAcik) {
    return (
      <div className="flex flex-col gap-3">
        <Buton gorunum="sessiz" onClick={() => setCanliBilgiAcik(false)}>
          Çocuğumun sayfasına dön
        </Buton>
        <CanliBilgilendirmeSayfasi />
      </div>
    );
  }

  if (acikRapor) {
    return <RaporGorunumu raporId={acikRapor} onGeri={() => setAcikRapor(null)} />;
  }

  /*
    MESAJLAR EKRANI DEVRALIYOR — rapor görünümüyle aynı desen.

    Gelen kutusunu portalın içine gömseydik, çocuk seçimi şeridiyle
    aynı sayfada iki ayrı gezinti olurdu; üstelik mesajlar ÇOCUK BAZLI
    DEĞİL (veli tek kişidir, yazışması da tektir) ve çocuk şeridinin
    altında durması "seçili çocuğun mesajları" gibi okunurdu.
  */
  if (mesajAcik) {
    return <Mesajlar kip="siz" onGeri={() => setMesajAcik(false)} />;
  }

  /*
    BİLDİRİMLER DE EKRANI DEVRALIYOR — mesajlarla aynı desen ve aynı
    gerekçe: portalın içine gömseydik çocuk seçimi şeridinin altında
    durur ve "seçili çocuğun bildirimleri" gibi okunurdu. Bildirim
    KİŞİYE gidiyor, çocuğa değil.

    "Kayda git" veli raporunu açıyor: yol `bildirim-yonlendirme.ts`
    içinde çözülüyor ve tanınmayan yolda düğme hiç çizilmiyor.
    Bildirim kutusu da kapanıyor — raporu açıp arkasında bir gelen
    kutusu bırakmak, geri düğmesinin nereye götüreceğini
    belirsizleştirirdi.
  */
  /*
    PROFİL GÖRSELİ — F-PPL-13. Mesaj ve bildirimle aynı desen: ekranı
    devralıyor, çünkü çocuk seçimi şeridinin altında durması "seçili
    çocuğun görseli" gibi okunurdu. Görsel VELİYE ait, çocuğa değil.
  */
  if (gorselAcik) {
    return <ProfilGorselim kip="siz" onGeri={() => setGorselAcik(false)} />;
  }

  if (bildirimAcik) {
    return (
      <Bildirimlerim
        kip="siz"
        onGeri={() => setBildirimAcik(false)}
        onGit={(hedef) => {
          setBildirimAcik(false);
          setAcikRapor(hedef.kayitId);
        }}
      />
    );
  }

  return (
    <div className="flex flex-col gap-5">
      <VeliBagiDogrulamaGirisi key={`veli-bagi:${aktif}`} ogrenciId={aktif} />
      {/* F-PAR-01 — birden fazla cocuk varsa gecis */}
      {/*
        SEKME DEĞİL, SÜZGEÇ DÜĞMELERİ — F-PAR-01, birden fazla çocuk.

        Elle yazılmış `role="tab"` şeridi vardı: `aria-selected` koyulmuş
        ama ok tuşlarıyla gezinme, gezinen odak ve `tabpanel` bağı YOKTU.
        Eksik kurulmuş bir ARIA deseni hiç yazmamaktan KÖTÜ.

        Tek çocukta şerit HİÇ çizilmiyor: tek seçenekli bir "seçim"
        seçim değildir.
      */}
      {cocuklar.data.length > 1 && (
        <Sekmeler
          etiket="Çocuklarım"
          secili={aktif}
          onSec={setSeciliCocuk}
          sekmeler={cocuklar.data.map((c) => ({ deger: c.id, etiket: c.ad }))}
        />
      )}

      {/*
        ================================================================
        SIRA: KİM → BU HAFTA → RAPORLAR → İLETİŞİM — UI/UX Dalga 1 (V1/F15/F16)
        ================================================================
        Kanıtta (390 px) onay kartı, bildirim ve mesaj girişleri en üstteydi;
        velinin portalı açma sebebi olan "Bu hafta" dördüncü sıradaydı ve
        onaylar tamamlandıktan sonra da öyle kalıyordu. Tek çocukta hangi
        çocuğa bakıldığı da hiçbir yerde yazmıyordu (başlık "Çocuğum").

        Onay kartı İKİYE bölündü: eksik zorunlu onay varsa (ya da durum
        okunamadıysa) EN ÜSTTE — kullanım ona bağlı; tamamsa EN ALTTA sakin
        bir giriş — geri çekme ve inceleme hakkı (KVKK) yine bir dokunuşta.
      */}
      <div>
        <p className="text-notr-600 text-xs">Çocuğunuz</p>
        <h2 className="text-notr-900 text-lg font-semibold">{cocuk.ad}</h2>
      </div>

      <CocukOnayGirisi
        key={`ust-${cocuk.userId}`}
        yer="ust"
        cocuk={cocuk}
        onAc={() => setOnayAcik(true)}
      />

      <VeliMentorumPaketi key={aktif} ogrenciId={aktif} />

      <SiparisOnayGirisi ogrenciId={aktif} onAc={() => setSiparisAcik(true)} />

      <HaftaOzeti ogrenciId={aktif} />
      <DenemeGelisimi ogrenciId={aktif} />
      <VeliHedefNetleri ogrenciId={aktif} />
      <RaporListesi ogrenciId={aktif} onAc={setAcikRapor} />
      {/* F-SES-02b — bağlantı yalnız veli görüşmesinde gelir (sunucu kuralı) */}
      <VeliYaklasanGorusmeleri ogrenciId={aktif} />
      <GorusmeOzetleri ogrenciId={aktif} />

      <BildirimGirisi onAc={() => setBildirimAcik(true)} />
      <MesajGirisi onAc={() => setMesajAcik(true)} />

      {/*
        F-NTF-08b — koç duyurusu. Çocuk şeridine bağlı DEĞİL: duyuru
        veliye (kişiye) gelir; iki çocuğun koçlarının duyuruları birlikte.
      */}
      <Duyurularim />

      <CocukOnayGirisi
        key={`alt-${cocuk.userId}`}
        yer="alt"
        cocuk={cocuk}
        onAc={() => setOnayAcik(true)}
      />

      {/* Görsel bir AYAR, bekleyen bir iş değil: en altta. */}
      <GorselGirisi onAc={() => setGorselAcik(true)} />

      {/* F-LIV-07 — küçük bağlantı: bilgilendirme, bir iş ya da karar değil. */}
      {canliAcik && (
        <div>
          <Buton gorunum="sessiz" onClick={() => setCanliBilgiAcik(true)}>
            Canlı çalışma izleme hakkında
          </Buton>
        </div>
      )}
    </div>
  );
}

/**
 * SİPARİŞ ONAYI GİRİŞİ — F-GAM-17, veli tarafı
 *
 * Bekleyen sipariş YOKSA ya da sorgu düşerse HİÇBİR ŞEY çizilmez: burası bir
 * bildirim kartı, bölüm değil. Mağaza modülü kapalıyken sunucu 404 döner ve bu
 * bir arıza değildir; kartı hatada göstermek veliyi boşuna korkutur. Gerçek
 * hata onay ekranı açılınca orada söylenir. Puan ve bakiye hiç yok (Emre S12).
 * Sayı ÇOCUK BAZLI: sunucu her onay satırında `ogrenciId` döndürür; kart
 * yalnız seçili çocuğun bekleyenlerini sayar.
 */
function SiparisOnayGirisi({ ogrenciId, onAc }: { ogrenciId: string; onAc: () => void }) {
  const { data } = useQuery({
    queryKey: ["veli-siparis-onaylari"],
    queryFn: veliSiparisOnaylari,
    retry: false,
  });
  const adet = Array.isArray(data) ? data.filter((o) => o.ogrenciId === ogrenciId).length : 0;
  if (adet === 0) return null;

  return (
    <Kart>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-notr-900 text-base font-semibold">Sipariş onayı</h2>
          <p className="text-notr-600 text-sm">Çocuğunuzun sipariş onayı bekliyor ({adet})</p>
        </div>
        <Buton onClick={onAc}>Siparişleri aç</Buton>
      </div>
    </Kart>
  );
}

/**
 * MESAJ GİRİŞİ — F-MSG, veli tarafı
 *
 * ================================================================
 * SAYACI OLMAYAN GELEN KUTUSU SESSİZ BİR KUTUDUR
 * ================================================================
 * Veli bu portala haftada bir bakıyor. Mesaj girişi sayı taşımasaydı,
 * koçun sorduğu bir soru günlerce görünmezdi ve gecikmenin bedelini
 * soruyu soran öderdi.
 *
 * Sayaç DÜŞERSE giriş yine çiziliyor, yalnızca sayısız. Kartı hatada
 * gizlemek, velinin "mesajlaşma yok" sonucunu çıkarmasına yol açardı
 * — bu dosyanın `Alinamadi` notundaki hata sınıfının aynısı.
 */
function MesajGirisi({ onAc }: { onAc: () => void }) {
  const { data } = useQuery({
    queryKey: ["veli-mesaj-sayac"],
    queryFn: mesajKutum,
    retry: false,
    // Anlık teslim yok (F-MSG): 60 sn, panelin bildirim ziliyle aynı ritim.
    refetchInterval: 60_000,
  });
  const okunmamis = data?.toplamOkunmamis ?? 0;

  return (
    <Kart>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-notr-900 text-base font-semibold">Mesajlar</h2>
          <p className="text-notr-600 text-sm">
            {okunmamis > 0 ? `${okunmamis} okunmamış mesajınız var.` : "Koçla ve kurumla yazışın."}
          </p>
        </div>
        <Buton gorunum={okunmamis > 0 ? "birincil" : "ikincil"} onClick={onAc}>
          Mesajları aç
        </Buton>
      </div>
    </Kart>
  );
}

/**
 * BİLDİRİM GİRİŞİ — F-NTF-09, veli tarafı
 *
 * ================================================================
 * VELİYE GİDEN BİLDİRİMLERİN HİÇBİR PENCERESİ YOKTU
 * ================================================================
 * Ölçüldü (07.09.2026): bugün gerçekten üretilen panel içi
 * bildirimlerin ÜÇÜ veliye gidiyor — gelişim raporu yayınlandı,
 * memnuniyet anketi gönderildi, muvafakat bekleniyor — ve bir de
 * herkese giden "yeni cihazdan giriş".
 *
 * Yani bu portalda bildirim kutusunu açmamak, gelen kutusunu
 * öğrenciye açıp bildirimlerin ÇOĞUNU alan kişiye hiç açmamak
 * olurdu: `BASLA.md`'nin "yarısını yazmak hiç yazmamaktan kötü"
 * sınıfı.
 *
 * ================================================================
 * MESAJ GİRİŞİNİN ÜSTÜNDE
 * ================================================================
 * `MesajGirisi` notu *"veli bu portala haftada bir bakıyor"* diyor.
 * Aynısı burada da geçerli ve bildirimin bir kısmı SÜRELİ (anket,
 * muvafakat); bekleyen bir iş varsa üstte durması gerekiyor.
 *
 * Sayaç düşerse giriş yine çiziliyor, yalnızca sayısız — kartı hatada
 * gizlemek, velinin "bildirim yok" sonucunu çıkarmasına yol açardı.
 */
function BildirimGirisi({ onAc }: { onAc: () => void }) {
  const { data } = useQuery({
    queryKey: ["veli-bildirim-sayac"],
    queryFn: bildirimSayaci,
    retry: false,
    // Mesaj sayacıyla aynı ritim; gerekçe `Uygulama.tsx` içinde.
    refetchInterval: 60_000,
  });
  const okunmamis = data?.okunmamis ?? 0;

  return (
    <Kart>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-notr-900 text-base font-semibold">Bildirimler</h2>
          <p className="text-notr-600 text-sm">
            {okunmamis > 0
              ? `${okunmamis} okunmamış bildiriminiz var.`
              : "Rapor, anket ve hesap hareketleri."}
          </p>
        </div>
        <Buton gorunum={okunmamis > 0 ? "birincil" : "ikincil"} onClick={onAc}>
          Bildirimleri aç
        </Buton>
      </div>
    </Kart>
  );
}

/**
 * PROFİL GÖRSELİ GİRİŞİ — F-PPL-13, veli tarafı
 *
 * Sayaç YOK ve olmamalı: burada bekleyen bir iş yok, bir ayar var.
 * Mesaj ve bildirim kartları sayı taşıyor çünkü orada birileri
 * bekliyor olabilir; burada bekleyen kimse yok.
 *
 * En ALTTA: portalın üstü "çocuğum ne yapıyor" sorusuna ait.
 */
function GorselGirisi({ onAc }: { onAc: () => void }) {
  return (
    <Kart>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <h2 className="text-notr-900 text-base font-semibold">Profil görselim</h2>
          <p className="text-notr-600 text-sm">Avatarınızı ya da fotoğrafınızı seçin.</p>
        </div>
        <Buton gorunum="ikincil" onClick={onAc}>
          Görseli aç
        </Buton>
      </div>
    </Kart>
  );
}

/**
 * BÖLÜM ALINAMADIĞINDA — kaybolmak yerine SÖYLÜYOR
 *
 * ================================================================
 * "VERİ YOK" İLE "VERİ GELMEDİ" AYRI ŞEYLER
 * ================================================================
 * Üç bölüm de hata durumunda `return null` yapıyordu; istek düşünce
 * bölüm başlığıyla birlikte ekrandan tamamen siliniyordu. Velinin
 * çıkaracağı sonuç *"rapor yok"* oluyordu — oysa raporlar duruyor,
 * yalnızca alınamadı.
 *
 * Aynı sınıf öğrenci uygulamasında da bulundu (C14.22). Ve bu dosya
 * kuralı BAŞKA BİR YERDE zaten uyguluyordu: `tamamlamaOrani` `null`
 * iken "%0" değil "—" gösteriliyor. Aynı dosyada uygulanan ve
 * uygulanmayan hâl yan yanaydı.
 *
 * Ton `uyari`, `hata` değil: veli için bu bir arıza değil, geçici bir
 * boşluk — ve bu ekranın kendi kuralı "kötü haber kırmızı değil".
 */
function Alinamadi({ ne, onTekrar }: { ne: string; onTekrar?: () => void }) {
  /*
    "TEKRAR DENE" — UI/UX Dalga 2 (M9, F17). Eskiden yalnızca "sayfayı
    yenileyebilirsiniz" yazıyordu: yenilemek BÜTÜN portalı baştan kurar, seçili
    çocuğu ve açık raporu sıfırlar; üç bölümden yalnız biri düşmüşken öteki
    ikisini de yeniden yüklemek gereksiz ve veliyi yarıda bırakıyor. Düğme
    YALNIZ düşen bölümün sorgusunu yeniden çalıştırır.
  */
  return (
    <div
      role="status"
      className="rounded-alan bg-uyari-500/15 text-uyari-600 flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2 text-sm"
    >
      <span>{ne} Bağlantınızı kontrol edip tekrar deneyebilirsiniz.</span>
      {onTekrar && (
        <Buton gorunum="ikincil" onClick={onTekrar}>
          Tekrar dene
        </Buton>
      )}
    </div>
  );
}

/** F-PAR-02 — bu haftanin ozeti. */
function HaftaOzeti({ ogrenciId }: { ogrenciId: string }) {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ["veli-ozet", ogrenciId],
    queryFn: () => veliOzet(ogrenciId),
  });

  if (isPending) return <IskeletKart adet={1} />;
  if (isError) {
    return (
      <Kart>
        <h2 className="text-notr-900 mb-3 text-base font-semibold">Bu hafta</h2>
        <Alinamadi ne="Bu haftanın özeti alınamadı." onTekrar={() => void refetch()} />
      </Kart>
    );
  }

  /*
    ================================================================
    "BU HAFTA" HANGI HAFTA — SUNUCU SOYLUYORDU, EKRAN SUSUYORDU
    ================================================================
    Baslik elle "Bu hafta" yaziyordu; sunucu ise sinirlari ZATEN
    gonderiyor (`VeliOzet.hafta.basi/sonu`). Bilgi teldeydi, ekranda
    yoktu — ogrenci PWA oturumunun ic ice alan taramasinda cikti.

    Velinin bakisindan fark somut: Pazartesi sabahi acan veli YENI
    haftayi goruyor ve rakamlar sifira yakin; Pazar aksami acan BITEN
    haftayi goruyor. Ikisi de "Bu hafta" yaziyordu.

    `null` ise (cozulemeyen deger) yalnizca "Bu hafta" yaziliyor —
    yanlis bir tarih araligi, hic tarih olmamasindan kotudur.

    Bicimlendirme `veli-hafta.ts` icinde ve `timeZone: "UTC"`
    kullaniyor; sebebi orada yazili (C14.1 gece yarisi sinifi).
  */
  const aralik = haftaAraligi(data.hafta.basi, data.hafta.sonu);

  return (
    <Kart>
      {/*
        ARALIK BASLIGIN ICINDE DEGIL, ALTINDA — ve bu bir uslup
        tercihi degil olcum sonucu. Ilk yazimda `<span>` olarak
        `<h2>`nin icine konmustu; `findByText("Bu hafta")` yazan iki
        mevcut test DUSTU ("text is broken up by multiple elements").

        Baslik bir DAYANAK: hem ekran okuyucu hem testler onu tek
        parca bir metin olarak buluyor. Icine ikinci bir metin koymak,
        o dayanagi her okuyan icin kiriyor. Aralik ayri bir satirda da
        ayni soruyu cevapliyor.
      */}
      <h2 className="text-notr-900 text-base font-semibold">Bu hafta</h2>
      {aralik !== null && <p className="text-notr-600 mb-3 text-sm">{aralik}</p>}
      {aralik === null && <div className="mb-3" />}

      {/*
        SIFIR GÖREVLİ HAFTANIN SEBEBİ YAZIYOR — UI/UX Dalga 1 (V5/F18).
        Kutular "0 / 0 · ölçülemedi" diyordu ve veli "çocuğum hiçbir şey
        yapmamış" ile "program yok"u ayırt edemiyordu. Kutular duruyor
        (ölçülmeyen yine "—", sıfıra çevrilmiyor); cümle nedenini söylüyor.
        Özet yalnız YAYINLANMIŞ programın görevlerini sayıyor
        (`veli.service.ts` `status: "PUBLISHED"`), yani sıfır = bu hafta
        yayınlanmış görev yok.
      */}
      {data.program.atanan === 0 && (
        <p className="rounded-alan bg-notr-50 text-notr-700 mb-3 px-3 py-2 text-sm">
          Bu hafta için program henüz yayınlanmadı.
        </p>
      )}

      <dl className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        <Olcum
          etiket="Atanan görev"
          deger={String(data.program.atanan)}
          alt={data.program.mazeretli > 0 ? `${data.program.mazeretli} mazeretli` : undefined}
        />
        <Olcum etiket="Tamamlanan" deger={String(data.program.tamamlanan)} />
        <Olcum
          etiket="Tamamlama"
          // ================================================================
          // OLCULEMEYEN DEGER "%0" DEGIL "—"
          // ================================================================
          // Sunucu `null` donuyor ve arayuz onu sifir gibi gostermiyor.
          // "%0 tamamlama" veliye cocugunun hicbir sey yapmadigini
          // soyler; oysa o hafta hic gorev atanmamis olabilir.
          deger={
            data.program.tamamlamaOrani === null
              ? "—"
              : `%${Math.round(data.program.tamamlamaOrani * 100)}`
          }
          alt={data.program.tamamlamaOrani === null ? "ölçülemedi" : undefined}
        />
        <Olcum
          etiket="Doğruluk"
          deger={
            data.calisma.basariOrani === null
              ? "—"
              : `%${Math.round(data.calisma.basariOrani * 100)}`
          }
          alt={
            data.calisma.basariOrani === null
              ? "veri girilmedi"
              : `${data.calisma.dogru}D / ${data.calisma.yanlis}Y`
          }
        />
      </dl>

      {data.calisma.toplamSureSaniye > 0 && (
        <p className="text-notr-600 mt-3 text-sm">
          Çalışma süresi: {Math.floor(data.calisma.toplamSureSaniye / 3600)} saat{" "}
          {Math.round((data.calisma.toplamSureSaniye % 3600) / 60)} dakika
        </p>
      )}

      <HaftaGrafikleri ozet={data} />
    </Kart>
  );
}

/**
 * BU HAFTA HALKASI + DÖRT HAFTALIK TAMAMLAMA — dalga 3 (F-PAR-01/03).
 *
 * Oran SUNUCUDAN (payda = atanan − mazeretli); burada formül kurulmuyor.
 * Ölçülmeyen hafta "%0" çizilmiyor: halka "Ölçülmedi" der, çizgide boşluk
 * kalır. Hiçbir haftada görev yoksa trend çizilmiyor (yukarıdaki "program
 * yayınlanmadı" cümlesi zaten söylüyor). Veliye oyunlaştırma/sıralama verisi
 * yok (mutabakat §5).
 */
function HaftaGrafikleri({ ozet }: { ozet: VeliOzet }) {
  const oran = ozet.program.tamamlamaOrani;
  const haftalar = ozet.haftalar ?? [];
  const olculenHafta = haftalar.filter((h) => h.tamamlamaOrani !== null).length;
  const yuzde = (o: number | null) => (o === null ? null : Math.round(o * 1000) / 10);
  // Ekran okuyucu özeti de Türkçe ondalıkla: "%9,1" ("%9.1" değil — canlıda ölçüldü).
  const yuzdeMetni = (n: number) =>
    new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(n);
  return (
    <div className="mt-4 grid gap-4 sm:grid-cols-[minmax(0,220px)_1fr]">
      <Halka
        baslik="Bu hafta tamamlama"
        deger={yuzde(oran)}
        bosMesaji="Bu hafta için tamamlama ölçülemedi: yayınlanmış görev yok."
      />
      {olculenHafta > 0 && (
        <CizgiGrafik
          baslik="Son 4 hafta tamamlama"
          birim="%"
          ozet={`Program olan hafta: ${olculenHafta} / ${haftalar.length}; bu haftaki tamamlama ${oran === null ? "ölçülemedi" : `%${yuzdeMetni(yuzde(oran)!)}`}.`}
          noktalar={haftalar.map((h) => ({
            tarih: h.haftaBasi.slice(0, 10),
            degerler: { oran: yuzde(h.tamamlamaOrani) },
          }))}
          seriler={[{ anahtar: "oran", etiket: "Tamamlama", ton: "marka" }]}
        />
      )}
    </div>
  );
}

/**
 * DENEME NET GELİŞİMİ — veli (dalga 3, F-PAR-03). Uç panelle aynı
 * (`deneme.sonuc.goruntule` LINKED; LINKED listesi yalnız portal erişimi açık
 * bağlardan kuruluyor). Hedef (F-EXM-09, 07.10.2026): koç girer, veli YALNIZ görür — düzenleme kontrolü yok.
 */
type DuzeltmeliVeliTrendi = Omit<Awaited<ReturnType<typeof denemeTrendi>>, "denemeler"> & {
  denemeler: Array<
    Awaited<ReturnType<typeof denemeTrendi>>["denemeler"][number] & {
      duzeltmeBekliyor?: true;
    }
  >;
};
function DenemeGelisimi({ ogrenciId }: { ogrenciId: string }) {
  const { data, isPending, isError, refetch } = useQuery<DuzeltmeliVeliTrendi>({
    queryKey: ["veli-deneme-trend", ogrenciId],
    queryFn: () => denemeTrendi(ogrenciId),
  });
  if (isPending) return <IskeletKart adet={1} />;
  return (
    <Kart>
      <h2 className="text-notr-900 mb-3 text-base font-semibold">Deneme net gelişimi</h2>
      {isError ? (
        <Alinamadi ne="Deneme sonuçları alınamadı." onTekrar={() => void refetch()} />
      ) : data.denemeler.length === 0 ? (
        <p className="text-notr-600 text-sm">Henüz sonuçlanmış deneme yok.</p>
      ) : (
        <div className="flex flex-col gap-2">
          <DenemeNetGrafigi denemeler={denemeNoktalari(data.denemeler)} baslik="Net gelişimi" />
          {/* F-EXM-24 — karne bayrağı kapalı olsa da veli bekleyen neti kesinleşmiş sanmamalı. */}
          {data.denemeler
            .filter((satir) => satir.duzeltmeBekliyor)
            .map((satir) => (
              <p role="status" key={`${satir.tarih}:${satir.ad}`}>
                {satir.ad}: düzeltiliyor
              </p>
            ))}
          <p className="text-notr-600 text-xs">Hedef netleri çocuğunuzun koçu belirler.</p>
          <Karne key={ogrenciId} ogrenciId={ogrenciId} istek={api} />
        </div>
      )}
    </Kart>
  );
}

/**
 * HEDEF NETLER — veli (F-EXM-09, 07.10.2026). Koç girer, veli YALNIZ görür: düzenleme kontrolü yok.
 * Uç `deneme.hedef.goruntule` LINKED (portal erişimi açık bağlı çocuk).
 *
 * 403/404 (izin ya da henüz bu uca sahip olmayan eski sunucu) kartı SESSİZCE gizler: velinin yapabileceği bir
 * şey yok ve portalın geri kalanı etkilenmemeli, o yüzden bu durumlarda yeniden denenmiyor. Ağ/sunucu
 * arızasında ise bölüm kaybolmaz, `Alinamadi` yazar — "hedef yok" sonucu çıkarılmasın.
 */
function VeliHedefNetleri({ ogrenciId }: { ogrenciId: string }) {
  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: ["veli-hedef-net", ogrenciId],
    queryFn: () => hedefNetim(ogrenciId),
    // Yeniden deneme yok (`MesajGirisi` ile aynı): 403/404 kalıcıdır, arızada "Tekrar dene" düğmesi var.
    retry: false,
  });
  if (isPending) return <IskeletKart adet={1} />;
  if (isError) {
    if (hedefYokYaniMi(error)) return null;
    return (
      <Kart>
        <h2 className="text-notr-900 mb-3 text-base font-semibold">Hedef netler</h2>
        <Alinamadi ne="Hedef netler alınamadı." onTekrar={() => void refetch()} />
      </Kart>
    );
  }
  return (
    <HedefNetleriGorunumu
      yanit={data}
      baslik="Hedef netler"
      bosMetni="Çocuğunuzun koçu henüz hedef net girmedi."
    />
  );
}

function Olcum({ etiket, deger, alt }: { etiket: string; deger: string; alt?: string }) {
  return (
    <div className="rounded-alan bg-notr-50 px-3 py-2">
      <dt className="text-notr-600 text-xs">{etiket}</dt>
      <dd className="text-notr-900 text-xl font-semibold tabular-nums">{deger}</dd>
      {alt && <dd className="text-notr-600 text-xs">{alt}</dd>}
    </div>
  );
}

/** F-PAR-04 — rapor arsivi. */
function RaporListesi({ ogrenciId, onAc }: { ogrenciId: string; onAc: (raporId: string) => void }) {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ["veli-raporlar", ogrenciId],
    queryFn: () => veliRaporlar(ogrenciId),
  });
  /*
    MEVCUT-01 — bağlantı TIKLAMADA istenir (15 dk geçerli): listeyle üretilseydi açık bırakılan sayfada
    ölmüş olurdu. Panelin `usePdfIndir`i ile aynı desen.
  */
  const pdfIndir = useMutation({
    mutationFn: (raporId: string) => veliRaporPdf(raporId),
    onSuccess: (s) => {
      window.open(s.url, "_blank", "noopener,noreferrer");
    },
  });

  // `isPending` tek basina `data`nin varligini garanti etmiyor: istek
  // basarisiz olduysa da pending biter ama veri gelmez. Ikisi AYRI
  // ele aliniyor — hata sessizce kaybolmamali.
  if (isPending) return <IskeletKart adet={1} />;
  if (isError) {
    return (
      <Kart>
        <h2 className="text-notr-900 mb-3 text-base font-semibold">Gelişim raporları</h2>
        <Alinamadi ne="Raporlar alınamadı." onTekrar={() => void refetch()} />
      </Kart>
    );
  }

  return (
    <Kart>
      <h2 className="text-notr-900 mb-3 text-base font-semibold">Gelişim raporları</h2>

      {data.length === 0 ? (
        <p className="text-notr-600 text-sm">Henüz yayınlanmış rapor yok.</p>
      ) : (
        <ul className="flex flex-col gap-2">
          {data.map((r) => (
            <li key={r.id}>
              <button
                type="button"
                onClick={() => onAc(r.id)}
                className="min-h-dokunma rounded-alan bg-notr-50 hover:bg-notr-100 flex w-full items-center justify-between gap-3 px-3 text-left"
              >
                <span>
                  <span className="text-notr-900 block text-sm font-medium">
                    {new Date(r.periodStart).toLocaleDateString("tr-TR", {
                      day: "numeric",
                      month: "long",
                    })}{" "}
                    –{" "}
                    {new Date(r.periodEnd).toLocaleDateString("tr-TR", {
                      day: "numeric",
                      month: "long",
                      year: "numeric",
                    })}
                  </span>
                  {r.readByParentAt && <span className="text-notr-600 block text-xs">Okundu</span>}
                </span>
                <span aria-hidden="true" className="text-marka-700">
                  →
                </span>
              </button>

              {/*
                ================================================================
                PDF İNDİRME — TIKLAMADA İMZALI BAĞLANTI (MEVCUT-01)
                ================================================================
                Tuval: "Raporu PDF indir" (`VeliPortali.dc.html`). Veliye tek
                çıktı yolu bu: raporu saklamak, eşine göstermek, yazdırmak.

                Eskiden `pdfUrl` (depo ANAHTARI) doğrudan `href` yapılıyordu:
                indirme uygulamanın göreli adresine gidip hiç çalışmıyordu.
                Artık veliye özel uç (bağ + yayın serviste doğrulanır) 15 dk
                geçerli bağlantı üretir.

                DÜĞMENİN İÇİNDE DEĞİL YANINDA: rapor satırının kendisi bir düğme
                ve iç içe etkileşimli öğe hem HTML olarak geçersiz hem de
                dokunmatikte hangisine bastığını belirsiz kılar.

                PDF yokken HİÇ çizilmiyor — üretim kuyrukta olabilir ve
                çalışmayan bir indirme düğmesi "bozuk düğme" olurdu.
              */}
              {r.pdfVar && (
                <button
                  type="button"
                  disabled={pdfIndir.isPending && pdfIndir.variables === r.id}
                  onClick={() => pdfIndir.mutate(r.id)}
                  className="min-h-dokunma text-marka-700 mt-1 inline-flex items-center px-3 text-sm underline"
                >
                  Raporu PDF indir
                </button>
              )}
              {pdfIndir.error instanceof ApiHatasi && pdfIndir.variables === r.id && (
                <p role="alert" className="text-hata-700 px-3 text-xs">
                  {pdfIndir.error.message}
                </p>
              )}
            </li>
          ))}
        </ul>
      )}
    </Kart>
  );
}

/** F-PAR-05 — yalnizca veliye acik gorusme ozetleri. */
function GorusmeOzetleri({ ogrenciId }: { ogrenciId: string }) {
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ["veli-gorusmeler", ogrenciId],
    queryFn: () => veliGorusmeler(ogrenciId),
  });

  if (isPending) return null;
  if (isError) {
    return (
      <Kart>
        <h2 className="text-notr-900 mb-3 text-base font-semibold">Görüşme özetleri</h2>
        <Alinamadi ne="Görüşme özetleri alınamadı." onTekrar={() => void refetch()} />
      </Kart>
    );
  }

  // Ozeti PAYLASILMAMIS gorusmeler listede yer kaplamasin: veli
  // "burada bir sey var ama gosterilmiyor" hissi yasamasin.
  //
  // Bu davranis KORUNUYOR ve hata halinden ayri: "paylasilan ozet yok"
  // bir OLGU, "alinamadi" ise bir bilinmezlik.
  const paylasilan = data.filter((g) => g.summary !== null);
  if (paylasilan.length === 0) return null;

  return (
    <Kart>
      <h2 className="text-notr-900 mb-3 text-base font-semibold">Görüşme özetleri</h2>
      <ul className="flex flex-col gap-3">
        {paylasilan.map((g) => (
          <li key={g.id} className="rounded-alan bg-notr-50 px-3 py-2">
            <p className="text-notr-600 text-xs">
              {new Date(g.scheduledAt).toLocaleDateString("tr-TR", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
              {g.durationMin ? ` · ${g.durationMin} dakika` : ""}
            </p>
            <p className="text-notr-800 mt-1 text-sm whitespace-pre-line">{g.summary}</p>
          </li>
        ))}
      </ul>
    </Kart>
  );
}

/** Tek rapor — acilinca OKUNDU isaretleniyor (F-REP-06). */
function RaporGorunumu({ raporId, onGeri }: { raporId: string; onGeri: () => void }) {
  const qc = useQueryClient();
  const [yorum, setYorum] = useState("");

  const { data, isPending, isError, error, refetch } = useQuery({
    queryKey: ["veli-rapor", raporId],
    queryFn: () => veliRapor(raporId),
  });

  const yorumGonder = useMutation({
    mutationFn: () => veliYorumYaz(raporId, yorum.trim()),
    onSuccess: () => {
      setYorum("");
      void qc.invalidateQueries({ queryKey: ["veli-rapor", raporId] });
    },
  });

  if (isPending) return <Iskelet satir={4} />;
  if (isError) {
    return (
      <BosDurum
        ton="hata"
        baslik="Rapor açılamadı"
        aciklama={error instanceof ApiHatasi ? error.message : undefined}
        eylem={
          <div className="flex flex-wrap gap-2">
            <Buton gorunum="ikincil" onClick={() => void refetch()}>
              Tekrar dene
            </Buton>
            <Buton gorunum="sessiz" onClick={onGeri}>
              Geri dön
            </Buton>
          </div>
        }
      />
    );
  }

  const dusukKapsam = data.dataCoverage !== null && data.dataCoverage < 50;

  return (
    <div className="flex flex-col gap-4">
      <Buton gorunum="sessiz" onClick={onGeri}>
        ← Raporlar
      </Buton>

      <article className="rounded-kart border-notr-200 bg-notr-0 shadow-kart border p-5">
        <h2 className="text-notr-900 text-lg font-semibold">
          {new Date(data.periodStart).toLocaleDateString("tr-TR", {
            day: "numeric",
            month: "long",
          })}{" "}
          –{" "}
          {new Date(data.periodEnd).toLocaleDateString("tr-TR", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </h2>

        {/*
          F-REP-08 — dusuk kapsam uyarisi VELIYE DE gosteriliyor.
          Yalnizca uzmana gostermek, veliye guvenilirligi belirsiz bir
          rapor sunmak olurdu.
        */}
        {dusukKapsam && (
          <p className="rounded-alan bg-uyari-500/15 text-uyari-600 mt-3 px-3 py-2 text-sm">
            Bu rapor kısmi veriye dayanmaktadır (veri kapsamı %{Math.round(data.dataCoverage!)}).
            Sayısal değerler bu sınırla birlikte okunmalıdır.
          </p>
        )}

        {data.draftContent && (
          <section className="mt-4">
            <h3 className="text-notr-900 text-sm font-semibold">Dönem özeti</h3>
            <pre className="rounded-alan bg-notr-50 text-notr-800 mt-1 p-3 font-sans text-sm whitespace-pre-wrap">
              {data.draftContent}
            </pre>
          </section>
        )}

        <Bolum baslik="Genel değerlendirme" metin={data.generalComment} />
        <Bolum baslik="Olumlu gelişmeler" metin={data.positives} />
        <Bolum baslik="Geliştirilecek alanlar" metin={data.improvements} />
        <Bolum baslik="Gelecek dönem hedefleri" metin={data.nextGoals} />
        <Bolum baslik="Size önerimiz" metin={data.parentAdvice} />

        {/*
          ================================================================
          RAPORU KİMİN YAZDIĞI — ADIYLA
          ================================================================
          Burada yalnızca *"çocuğunuzun eğitim koçu"* yazıyordu. Tuval
          adı istiyor: *"1 – 28 Ağustos 2026 · uzman Serkan Aksoy"*
          (`VeliPortali.dc.html`).

          Neden önemli: bir çocuk hakkında yazılmış değerlendirmeyi
          kimin yazdığı, velinin **soru soracağı kişiyi** belirliyor.
          Genel ifade, birden fazla uzmanla çalışan bir öğrencide
          kimseyi işaret etmiyor.

          `hazirlayan` null olabilir (uzmanın kaydı arşivlenmişse) ve o
          zaman ad SATIRI HİÇ yazılmıyor — yer tutucu bir ad uydurmak,
          sunucunun bilerek yapmadığı şeyi ekranda yapmak olurdu.
          Genel cümle her hâlde kalıyor: sayısal bölümün sistem
          tarafından üretildiği bilgisi ada bağlı değil.
        */}
        <p className="border-notr-100 text-notr-600 mt-5 border-t pt-3 text-xs">
          Sayısal bölüm sistem tarafından üretilmiş, değerlendirme bölümleri
          {data.hazirlayan ? (
            <>
              {" "}
              <span className="text-notr-700 font-medium">{data.hazirlayan}</span> tarafından
              yazılmıştır.
            </>
          ) : (
            " çocuğunuzun eğitim koçu tarafından yazılmıştır."
          )}
        </p>
      </article>

      {/* F-REP-06 — istege bagli veli yorumu */}
      <Kart>
        <h3 className="text-notr-900 text-sm font-semibold">
          {data.parentComment ? "Yorumunuz" : "Eklemek istediğiniz bir şey var mı?"}
        </h3>
        {data.parentComment ? (
          <p className="text-notr-700 mt-2 text-sm whitespace-pre-line">{data.parentComment}</p>
        ) : (
          <div className="mt-2 flex flex-col gap-2">
            <Alan
              etiket="Yorumunuz"
              value={yorum}
              onChange={(e) => setYorum(e.target.value)}
              yardim="Koçunuz görecek. İsteğe bağlıdır."
            />
            <Buton
              disabled={yorum.trim().length === 0}
              yukleniyor={yorumGonder.isPending}
              onClick={() => yorumGonder.mutate()}
            >
              Gönder
            </Buton>
          </div>
        )}
      </Kart>
    </div>
  );
}

function Bolum({ baslik, metin }: { baslik: string; metin: string | null }) {
  // Bos bolum HIC yazilmiyor — PDF'teki kararla ayni. "Geliştirilecek
  // alanlar: —" yazan bir rapor, uzmanin doldurmadigini veliye ilan
  // etmekten baska bir sey yapmaz.
  if (!metin || metin.trim().length === 0) return null;
  return (
    <section className="mt-4">
      <h3 className="text-notr-900 text-sm font-semibold">{baslik}</h3>
      <p className="text-notr-800 mt-1 text-sm whitespace-pre-line">{metin}</p>
    </section>
  );
}

function CocukOnayGirisi({
  cocuk,
  onAc,
  yer,
}: {
  cocuk: VeliCocuk;
  onAc: () => void;
  /**
   * "ust": yalnız dikkat isteyen hâlde (eksik zorunlu onay, okunamayan
   * durum, eski API'de kullanıcı kimliği yok). "alt": her şey tamamken.
   * İki örnek AYNI sorgu anahtarını kullanıyor — tek istek gidiyor.
   */
  yer: "ust" | "alt";
}) {
  const durum = useQuery({
    queryKey: ["cocuk-onaylari", cocuk.userId],
    queryFn: () => rizaDurumu(cocuk.userId),
    enabled: Boolean(cocuk.userId),
    retry: false,
  });
  const dikkat =
    !cocuk.userId ||
    durum.isError ||
    (durum.data !== undefined && durum.data.engelleyenEksikler.length > 0);
  const tamam = durum.data !== undefined && durum.data.engelleyenEksikler.length === 0;
  if (yer === "ust" ? !dikkat : !tamam) return null;

  if (yer === "alt") {
    return (
      <Kart>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div>
            <h2 className="text-notr-900 text-base font-semibold">Çocuğumun onayları</h2>
            <p className="text-notr-600 text-sm">Zorunlu onaylar tamam.</p>
          </div>
          <Buton gorunum="ikincil" onClick={onAc}>
            Onayları aç
          </Buton>
        </div>
      </Kart>
    );
  }

  return (
    <Kart>
      <h2 className="text-base font-semibold">Çocuğumun onayları</h2>
      {durum.data && durum.data.engelleyenEksikler.length > 0 && (
        <div role="alert" className="bg-uyari-500/15 my-2 p-3">
          <strong>{cocuk.ad} için zorunlu onaylar eksik. Onaylanmadan kullanım açılmaz.</strong>
          <ul>
            {durum.data.engelleyenEksikler.map((tur) => (
              <li key={tur}>{RIZA_ADI[tur]}</li>
            ))}
          </ul>
        </div>
      )}
      {durum.isError && (
        <div role="alert" className="flex flex-wrap items-center gap-3">
          <p>Onay durumu alınamadı. Onayları açarak yeniden deneyebilirsiniz.</p>
          <Buton gorunum="ikincil" onClick={() => void durum.refetch()}>
            Tekrar dene
          </Buton>
        </div>
      )}
      {!cocuk.userId && <p>Güncelleme bekleniyor, sayfayı yenileyin</p>}
      <Buton onClick={onAc} disabled={!cocuk.userId}>
        Onayları aç
      </Buton>
    </Kart>
  );
}

// F-MNT-04/05 — veliye yalnız paket durumu ve kendi rıza belgesi sunulur.
export function VeliMentorumPaketi({ ogrenciId }: { ogrenciId: string }) {
  const [rizaAcik, setRizaAcik] = useState(false);
  const paket = useQuery({
    queryKey: ["veli-mentorum-paketi", ogrenciId],
    queryFn: ({ signal }) =>
      api<{ paketAdi: string | null; kalanGun: number | null }>(
        `/mentorum/erisim/${encodeURIComponent(ogrenciId)}`,
        { signal, taze: true },
      ),
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: "always",
  });
  if (paket.error instanceof ApiHatasi && paket.error.kod === "MODUL_KAPALI") return null;
  return (
    <Kart baslik="Mentörüm Yanımda" className="min-w-0 [overflow-wrap:anywhere]">
      {paket.isPending ? (
        <Iskelet satir={1} />
      ) : paket.isError ? (
        <>
          <p role="alert">{mentorumHataMetni(paket.error)}</p>
          <Buton gorunum="ikincil" onClick={() => void paket.refetch()}>
            Mentörüm paketini yeniden dene
          </Buton>
        </>
      ) : (
        <>
          <p>Paket: {paket.data.paketAdi ?? "Paket tanımlanmamış"}</p>
          <p>
            {paket.data.kalanGun === null
              ? "Koçluk üyeliği sürdükçe"
              : `Kalan süre: ${paket.data.kalanGun} gün`}
          </p>
          <Buton
            gorunum="ikincil"
            onClick={() => setRizaAcik((acik) => !acik)}
            aria-expanded={rizaAcik}
          >
            Mentörüm rıza işlemleri
          </Buton>
          {rizaAcik && (
            <MentorumRizasi
              key={ogrenciId}
              ogrenciId={ogrenciId}
              veli
              onDegisti={() => {
                void paket.refetch();
              }}
            />
          )}
        </>
      )}
    </Kart>
  );
}
